module.exports = __webpack_public_path__ + "static/media/payment-failed.9ebd5266.png";